<template>
  <div v-if="showVisaAndPermitTile" class="flex flex-col">
    <router-link
      :to="{
        name: 'visa-permit',
        params: { applicationId: applicationId },
      }"
      class="flex flex-row justify-start items-center mb-2"
    >
      <CheckMarkIcon :completed="completed" />
      <p
        class="text-sm font-semibold ml-4 ml-4"
        :class="completed ? 'text-gray-650' : 'text-cyan-700'"
      >
        Visa &amp; Permits
      </p>
    </router-link>
  </div>
</template>

<script>
import CheckMarkIcon from "../SharedComponents/CheckMarkIcon.vue";
import formIoApi from "../../../mixins/formIoApi.js";
import postFormRules from "../../../mixins/postFormRules.js";
import { mapState } from "vuex";
import { eventBus } from "@/eventBus.js";

export default {
  name: "VisaAndPermitCard",
  components: { CheckMarkIcon },
  mixins: [formIoApi, postFormRules],
  data() {
    return {
      formURL: "visaandpermits",
    };
  },
  computed: {
    ...mapState(["program", "currentApplicationSubmissions"]),
    completed() {
      return Object.hasOwn(this.currentApplicationSubmissions, this.formURL);
    },
    applicationId() {
      return this.$route.params.applicationId;
    },
  },
  async mounted() {
    if (this.showVisaAndPermitTile) {
      eventBus.$emit("addPreDepartureForm", {
        label: "Visa & Permits",
        ruleName: "Visa Upload",
        routeName: "visa-permit",
        submitted: this.completed,
        travelSection: true,
      });
    }
  },
};
</script>
